import React from 'react';
import { OrderSuccessOverlay } from '../../../components/order/success-overlay/OrderSuccessOverlay';
import { useRouter } from '../../../hooks/router';
import { OrderIdPage } from '../../../pages/order/id/OrderIdPage';

interface Props {
    orderId: number;
}

export function SpcCheckoutOrderPlaced({ orderId }: Props) {
    const router = useRouter();

    return <OrderSuccessOverlay redirectTo={router.replaceParams(OrderIdPage, { orderId })} />;
}
